module.exports = __webpack_public_path__ + "img/logo_smarky_ol.bd18772a.png";